import { Component, OnChanges, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { OportunitatsService } from './oportunitats.service';
import { DialogOportunitats } from '../dialog/oportunitats/dialog.component.oportunitats';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { ListOportunitatsService } from './list.service';
import { saveAs } from 'file-saver';

import { IFROportunitats } from './oportunitats.interfaces';

@Component({
  selector: 'mcrit-gestio-oportunitats',
  templateUrl: 'oportunitats.component.html',
  styleUrls: ['oportunitats.component.scss']
})
export class OportunitatsComponent implements OnInit {
   @Input('elementList') elementList: any;
   @Output('requestRows') requestRows = new EventEmitter();

   private routeParamsSubs: any;

   public showAsyncProgress: boolean = false;
   public oportunitatsData: Array<IFROportunitats> = [];

   private activeFilters: any = {};
   private currentOrdering: any = {};
   private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

   public firstRegisterShown: number = 0;
   public lastRegisterShown: number;
   public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
   public data: Array<number> = [];

   public showFilters: boolean = true;
   public orderingParameters: any;
   public export: boolean = false;
   public showDialog: boolean = false;
   public editOportunitatsData: IFROportunitats;
   private OportunitatsModel: IFROportunitats = {
      'id': 'NEW',
      'titol': null,
      'tipus': null,
      'estat': null,
      'pressupost': null,
      'ambit': null,
      'canvi_moneda': null,
      'moneda': null,
      'observacions': null,
      'data_limit_presentacio': null,
      'data_publicacio': null,
      'coordinador': null,
      'tecnic_suport': null,
      'url': null,
      'codi': null,
      'nota': null,
      'prioritat': null,
      'participacio': null,
      'tipus_expressio': null,
      'solvencia': null,
      'memoria_tecnica': null,
      'perfils_tecnics': null,
      'avaluacio': null,
      'puntuacio_possible': null,
      'socis_possibles': null,
      'data_nota': null
   };

   public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
   }

   public computeActiveFilters($event){
     this.activeFilters = $event;

     this.firstRegisterShown = 1 + this.listOportunitatsService.currentPage * this.listOportunitatsService.rowsPerPage;
     this.requestRowsToParent(false);
   }

   private computeDisplayedRows(): void {
     this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listOportunitatsService.rowsPerPage - 1, this.oportunitatsData.length);
   }

   public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent(false);
  }

  private requestRowsToParent(exportar): void {
      this.oportunitatsService.get(
        this.listOportunitatsService.rowsPerPage, //Limit
        (this.firstRegisterShown?this.firstRegisterShown:1) - 1, //Skip
        this.activeFilters //FILTRE DELS REGISTRES QUE ES MOSTREN A INICI

        ,{}//Conds a aplicar. Per defecte LIKE %%
        ,this.currentOrdering //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
        , exportar
      ).subscribe(
        data => {
          if(!exportar){this.oportunitatsData = data["rows"];this.computeDisplayedRows();}
          else{
            var file = new Blob(["\ufeff", data], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }
        },
        error => console.log(error)
      );
  }

  public addOportunitat(): void {
    this.editOportunitatsData = Object.assign({}, this.OportunitatsModel);
    let dialogFactRef=this.dialog.open(DialogOportunitats, {height: '550px', width: '1200px', data: this.editOportunitatsData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editOportunitatsData = results;
      this.addOrUpdate();
    });
    //this.showDialog = true;
  }

  public editOportunitat(oportunitat: IFROportunitats): void {
    //this.editOportunitatsData = Object.assign({}, this.OportunitatsModel);
    this.editOportunitatsData = oportunitat;
    let dialogFactRef=this.dialog.open(DialogOportunitats, {disableClose: true, height: '590px', width: '1200px', data: this.editOportunitatsData })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editOportunitatsData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;
    if (this.editOportunitatsData.id === 'PRE') {//Convertir a manifestacions d'interès
        this.oportunitatsService.converteixPreProposta(this.editOportunitatsData).subscribe(retorm => {
          console.log("L'oportunitat s'ha mogut a manifestació d'interès");});
    }else
    if (this.editOportunitatsData.id === 'PRO') {//Convertir a proposta
        this.oportunitatsService.converteixProposta(this.editOportunitatsData).subscribe(retorm => {
          console.log("L'oportunitat s'ha mogut a proposta");});
        this.oportunitatsService.sendMessage((this.editOportunitatsData.coordinador?this.editOportunitatsData.coordinador+";":"")+"pol.ravenat@mcrit.com","AVIS-GESTIO-OPORTUNITAT","S'ha convertit una oportunitat en proposta "+this.editOportunitatsData.codi);
    }else
    if (this.editOportunitatsData.id === 'NEW') {//crear oportunitat
      this.oportunitatsService.createOportunitats(this.editOportunitatsData)
        .subscribe(newClientSoci => {
          this.oportunitatsService.sendMessage("andreu.ulied@mcrit.com;andreu.esquius@mcrit.com","AVIS-GESTIO-OPORTUNITAT","S'ha creat una nova oportunitat "+this.editOportunitatsData);
          console.log("S'ha creat l'element");window.location.reload();});
    } else {//actualitzar  oportunitat
      this.oportunitatsService.updateOportunitats(<number> this.editOportunitatsData.id, this.editOportunitatsData)
        .subscribe(updatedClientSoci => {console.log("S'han desat les dades");
      //Actualitza la llista amb les modificacions
      let updateItem = this.oportunitatsData.find(item => item.id == this.editOportunitatsData.id);
      let index = this.oportunitatsData.indexOf(updateItem);
      this.editOportunitatsData[index] = this.editOportunitatsData;
      });
    };
  }

  public exportar(){this.export=true;this.requestRowsToParent(true);};
  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public requestPrevious(): void {
     this.listOportunitatsService.currentPage = Math.max(0, this.listOportunitatsService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent(false);
  }

  public requestNext(): void {
     this.listOportunitatsService.currentPage = this.listOportunitatsService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent(false);
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listOportunitatsService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent(false);
  }

  public oportunitatsFilters: Array<any>
  public ordreCamps: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, private oportunitatsService: OportunitatsService, public dialog:MatDialog, public listOportunitatsService: ListOportunitatsService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.ordreCamps = [];

    this.oportunitatsFilters = [
    {
      inputs: [
        {
          name: 'Estat', 
          type: 'checkbox',
          values: [
            { text: this.translate.instant('oportunitats.estats.statePendent'), name: 'statePendent', value: false },
            { text: this.translate.instant('oportunitats.estats.statePossible'), name: 'statePossible', value: false },
            { text: this.translate.instant('oportunitats.estats.stateSi'), name: 'stateSi', value: false },
            { text: this.translate.instant('oportunitats.estats.stateNo'), name: 'stateNo', value: false },
            { text: this.translate.instant('oportunitats.estats.stateDataPost'), name: 'stateDataPost', value: false }
          ]
        }
        /*,{
          name: 'data_limit_presentacio',
          type: 'checkbox',
          values: [
            {
              text: 'posterior a l\'actual',
              name: 'stateDataPost',
              value: false
            }
          ]
        }*/
      ]
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
            { text: this.translate.instant('oportunitats.filtrar.titol'), name: 'titol', value: this.listOportunitatsService.getSearchValues('titol') },
            { text: this.translate.instant('oportunitats.filtrar.data_limit_presentacio'), name: 'data_limit_presentacio', value: this.listOportunitatsService.data_limit_presentacio },
            { text: this.translate.instant('oportunitats.filtrar.coordinador'), name: 'coordinador', autocomplete: 'tecnicMcrit', value: this.listOportunitatsService.getSearchValues('coordinador') },
            { text: this.translate.instant('projectsList.campsCerca.sectors'), name: 'ambit', autocomplete: 'ambitOp', value: this.listOportunitatsService.getSearchValues('ambit') }
          ]
        }
      ]
    }
  ];
  this.computeActiveFilters({stateDataPost: true});
  this.orderingParameters = this.oportunitatsFilters.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});

    ['data_limit_presentacio'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
    this.computeActiveFilters({  });
  }

}
